const _temp0 = require("./beeps/carson.json");
const _temp1 = require("./beeps/darebin.json");
const _temp2 = require("./beeps/silent.json");
const _temp3 = require("./beeps/standard.json");
const _temp4 = require("./beeps/sundrive.json");
module.exports = {
  "carson": _temp0,
  "darebin": _temp1,
  "silent": _temp2,
  "standard": _temp3,
  "sundrive": _temp4
}